import { Layout } from 'antd';

const { Header } = Layout;

export default Header;
